export const breakpoints = {
  sm: 640,
  md: 819,
  lg: 1179,
  xl: 1400,
  xxl: 1800,
};
